import {WebApiRequest, HTTP_GET, HTTP_POST, HTTP_PUT, HTTP_DELETE} from "tools/webservice";

export const getSurveyTypeStamps = (customerNumber, surveyTypeCode, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/customers/${customerNumber}/survey-type/${surveyTypeCode}/stamps`,
  successCallback: successCallback,
  mountedRef: mountedRef,
});

export const addSurveyTypeStamp = (customerNumber, surveyTypeCode, stamp, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  payload: stamp,
  endpoint: `/customers/${customerNumber}/survey-type/${surveyTypeCode}/stamps`,
  successCallback: successCallback,
  mountedRef: mountedRef,
});

export const removeSurveyTypeStamp = (customerNumber, surveyTypeCode, stampId, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_DELETE,
  endpoint: `/customers/${customerNumber}/survey-type/${surveyTypeCode}/stamps/${stampId}`,
  successCallback: successCallback,
  mountedRef: mountedRef,
});

export const editSurveyTypeStamp = (customerNumber, surveyTypeCode, stamp, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_PUT,
  payload: stamp,
  endpoint: `/customers/${customerNumber}/survey-type/${surveyTypeCode}/stamps`,
  successCallback: successCallback,
  mountedRef: mountedRef,
});